
import { Component, Vue } from 'vue-property-decorator';
import Blog from '@/components/blog.vue';

@Component({
  components: {
    Blog,
  },
})
export default class TheJourney extends Vue {
  public async mounted() {
    let elHtml = document.getElementsByTagName('html')[0];
    elHtml.style.overflowY = 'hidden';
  }

  public destroyed() {
    let elHtml = document.getElementsByTagName('html')[0];
    elHtml.style.overflowY = 'auto';
  }
}
